import { render } from "./HiddenInputFieldsWithIds.vue?vue&type=template&id=aff88174"
import script from "./HiddenInputFieldsWithIds.vue?vue&type=script&lang=js"
export * from "./HiddenInputFieldsWithIds.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__